import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-slate-950 pt-16 pb-8 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          
          <div>
            <div className="flex flex-col items-start mb-6">
              <img 
                src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1774369849101-image.png" 
                alt="MK Netzbau GmbH Logo" 
                className="h-24 w-auto object-contain bg-white rounded-xl p-2 shadow-md mb-2"
              />
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Ihr kompetenter Partner für den ganzheitlichen Glasfasernetzausbau. Spezialisiert auf NE3 Tiefbau & Hausanschlüsse sowie NE4 Inhouse-Installationen.
            </p>
          </div>

          <div>
            <h4 className="text-white font-bold mb-6 uppercase text-sm tracking-wider">Unternehmensführung</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li>Geschäftsführer: Malik Kömeagac</li>
              <li>Organisation:</li>
              <li>Fikri Dilci</li>
              <li>Mustafa Tapkiran</li>
              <li>Hüseyin Elmas</li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-6 uppercase text-sm tracking-wider">Rechtliches & Bank</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li>Steuernummer: 02023963174</li>
              <li className="pt-3"><strong>Bankverbindung:</strong></li>
              <li>IBAN: DE42 5176 2434 0028 1790 06</li>
              <li>SWIFT/BIC: GENODE51BIK</li>
            </ul>
          </div>

        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-slate-500 text-sm mb-4 md:mb-0">
            &copy; {new Date().getFullYear()} MK Netzbau GmbH. Alle Rechte vorbehalten.
          </p>
          <div className="flex space-x-6 text-sm">
            <Link to="/impressum" className="text-slate-500 hover:text-white transition-colors">Impressum</Link>
            <Link to="/datenschutz" className="text-slate-500 hover:text-white transition-colors">Datenschutz</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;